// Thin wrapper sobre dataCache para compatibilidade com componentes que
// escutam "turmas:changed". Evita cache duplicado.
import { getTurmasCache, carregarTurmas } from "./dataCache";

let _loadPromise = null;

function notificar() {
  window.dispatchEvent(new Event("turmas:changed"));
}

// Sincroniza dataCache e emite evento específico de turmas.
export async function recarregarTurmas(instituicaoId) {
  const lista = await carregarTurmas(instituicaoId);
  notificar();
  return lista;
}

export async function recarregarSeNecessario(instituicaoId) {
  const cache = getTurmasCache();
  if (cache.length > 0) return cache;
  if (!_loadPromise) {
    _loadPromise = recarregarTurmas(instituicaoId).finally(() => {
      _loadPromise = null;
    });
  }
  return _loadPromise;
}

export function getTurmas(instituicaoId) {
  const cache = getTurmasCache();
  if (cache.length === 0 && !_loadPromise) {
    recarregarSeNecessario(instituicaoId).catch(() => {});
  }
  return cache;
}
